module.exports = __webpack_public_path__ + "static/ant-support-1750b6d3c9a92935f79d3c0fea0a25da.png";